import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Carousel, Image } from "antd";
import { UserIcon } from "components";
import { documentService } from "services";

// Composant qui render un Carousel.
class CarouselPhotos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
    };
    this.number_image = 16;
    this.fetchImages = this.fetchImages.bind(this);
    this.carousel_speed = 10;
    this.carousel = React.createRef();
  }

  componentDidMount() {
    this.fetchImages();
    this.timer = setInterval(() => this.carousel.next(), this.carousel_speed * 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }

  fetchImages() {
    documentService
      .last(this.number_image, this.props.filters || {})
      .then((result) => {
        this.setState({ images: result });
      })
      .catch((e) => {
        this.setState(() => {
          throw new Error(e);
        });
      });
  }

  buildRow = (rowImages, rowIndex) => {
    const items = [];
    for (var slot = 0; slot < 4; slot++) {
      if (this.props.spacer && slot == 2) {
        items.push(
          <div key={`spacer-${rowIndex}`} className="carousel-spacer" />,
        );
      }
      if (rowImages[slot]) {
        items.push(
          <div key={`img-${rowIndex * 4 + slot}`} className="carousel-subitem fred">
            <img width={400} height={200} src={rowImages[slot].url.thumb.url} />
            <span>{rowImages[slot].project_name}</span>
          </div>,
        );
      } else {
        items.push(
          <div key={`empty-${rowIndex}-${slot}`} className="carousel-subitem fred carousel-subitem--empty" />,
        );
      }
    }
    return items;
  };

  sortImages = () => {
    const { images } = this.state;
    var rows = [];
    for (var i = 0; i < images.length; i += 4) {
      rows.push(this.buildRow(images.slice(i, i + 4), rows.length));
    }
    return rows;
  };

  render() {
    const images_sorted = this.sortImages();

    return (
      <Carousel className="carousel" ref={(node) => (this.carousel = node)}>
        {images_sorted.map((images, i) => (
          <div key={i} className="carousel-item">{images}</div>
        ))}
      </Carousel>
    );
  }
}

export default CarouselPhotos;
